import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiAuth } from '../auth-client';
const LIST_KEY = ['auth', 'users'];
function userListPath(filters) {
    const query = new URLSearchParams();
    query.set('page', String(filters.page));
    query.set('per_page', String(filters.perPage));
    if (filters.search?.trim())
        query.set('search', filters.search.trim());
    if (filters.isBanned !== undefined)
        query.set('is_banned', String(filters.isBanned));
    if (filters.role)
        query.set('role', filters.role);
    return `/admin/users?${query.toString()}`;
}
export function useAuthUsers(filters) {
    return useQuery({
        queryKey: [...LIST_KEY, filters],
        queryFn: () => apiAuth(userListPath(filters)),
        placeholderData: (previous) => previous,
    });
}
export function useAuthUser(userId) {
    return useQuery({
        queryKey: [...LIST_KEY, userId],
        queryFn: () => apiAuth(`/admin/users/${encodeURIComponent(userId ?? '')}`),
        enabled: !!userId,
        retry: false,
    });
}
export function useUpdateAuthUserRole() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ userId, role }) => apiAuth(`/admin/users/${encodeURIComponent(userId)}/role`, {
            method: 'PATCH',
            body: { role },
        }),
        onSuccess: (user) => {
            queryClient.setQueryData([...LIST_KEY, user.id], user);
            queryClient.invalidateQueries({ queryKey: LIST_KEY });
        },
    });
}
